import * as React from "react";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { PageNotFound } from "./PageNotFound";
import { RouteDefinition } from "../../App";

export const redirectRoutes: RouteDefinition[] = [
    {
        path: "*",
        content: () => <PageNotFound />,
        header: () => <SherpaHeader headerType="Home" />,
        footer: () => <SherpaFooter variant="LivePage" />
    }
];